import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestService {
  constructor(private http: HttpClient) {}

  public getCurrentLocationInfo(): Observable<any> {
    return this.http.get(`http://ip-api.com/json`);
  }
}
